import { FC } from 'react';
import SubTableV1 from 'src/components/commons/subTableV1';
import PageContainer from 'src/components/pageContainer/PageContainer';
import useStageGroup from './hooks/useStageGroup';

const StageGroup: FC = () => {
  const {
    data,
    columns,
    addNewRecord,
    editRecord,
    deleteRecord,
    autocompleteFieldSearch,
    sortRecord,
  } = useStageGroup();

  return (
    <PageContainer>
      <div style={{ paddingLeft: 50, paddingRight: 50 }}>
        <SubTableV1
          data={data ?? []}
          columns={columns ?? []}
          columnFilterShown
          total
          nonSelectable
          showAutoIncrement
          actionCell={['delete']}
          scroll={{ y: '55vh', x: 'auto' }}
          postData={addNewRecord}
          editRecord={editRecord}
          onDeleteClick={deleteRecord}
          autocompleteFieldProvider={autocompleteFieldSearch}
          onSortChange={sortRecord}
          allowGlobalEditActive
          id='stage-group'
        />
      </div>
    </PageContainer>
  );
};

export default StageGroup;
